import React from 'react'
import { pick } from 'lodash-es'
import { IconMaps } from '@ow/icons'
import { useProjectStore } from '@vt/hooks'

// 默认样式
const defaultElementsStyle = {
  title: {
    fontWeight: 'bold',
    fontSize: '16px',
    color: 'rgb(var(--ow-text-color))',
  },
  message: {
    fontSize: '14px',
  },
}
const Text = function ({ props }) {
  const { message, style, icon, actionType } = props

  const defaultStyle = defaultElementsStyle[actionType]
  // 取定制组件
  const { customCompsMap } = useProjectStore((state) =>
    pick(state, ['customCompsMap'])
  )
  const { MessageComponent } = customCompsMap || {}

  return (
    <div
      className="flex flex-row justify-start items-center"
      style={{ ...defaultStyle, ...style, gap: '9px' }}
    >
      {icon && (
        <IconMaps type={icon} width={18} height={18} fill="currentColor" />
      )}
      {message || (
        <>
          {actionType === 'message' && MessageComponent && <MessageComponent />}
        </>
      )}
    </div>
  )
}

export default Text
